import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatDialogConfig } from '@angular/material';
import { CustomDateComponent } from '../reports/customdate/custom-date.component';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
var EmsalertreportComponent = /** @class */ (function () {
    function EmsalertreportComponent(matDialog, transMngSer, deviceManagerSer, reportService, EmsdashboardService) {
        this.matDialog = matDialog;
        this.transMngSer = transMngSer;
        this.deviceManagerSer = deviceManagerSer;
        this.reportService = reportService;
        this.EmsdashboardService = EmsdashboardService;
        this.deviceIds = [];
        this.parameters = ['All', 'Low Power Factor'];
        this.reportColumns = ['Date', 'deviceid', 'energyMeterId', 'parametername', 'thresholdvalue', 'actualvalue'];
        this.timeOptions = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
    }
    EmsalertreportComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.deviceManagerSer.getEMSDeviceId(JSON.parse(localStorage.getItem('userData')).userid).subscribe(function (response) {
                    var Deviceids = [];
                    response.result.forEach(function (value) {
                        Deviceids.push(value.deviceId + "(" + value.sitename + ")");
                    });
                    _this.filters('DeviceID', Deviceids[0]);
                    _this.deviceIds = Deviceids;
                    _this.selectedDevice = Deviceids[0];
                    console.log("Selected devuice id", _this.selectedDevice);
                });
                return [2 /*return*/];
            });
        });
    };
    EmsalertreportComponent.prototype.exportToPdf = function () {
        var docDefinition = {
            content: [
                {
                    table: {
                        headerRows: 1,
                        widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                        body: [this.reportColumns].concat(this.reportData.map(function (row) { return Object.values(row); }))
                    }
                }
            ]
        };
        pdfMake.createPdf(docDefinition).download('report.pdf');
    };
    EmsalertreportComponent.prototype.refreshData = function () {
        this.ngOnInit();
    };
    EmsalertreportComponent.prototype.filters = function (type, param) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var param_1, metername_1, dialogConfig, dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                param = param.split('(')[0];
                if (type == "DeviceID") {
                    this.device = param;
                    this.transMngSer.getEnergyMeters(param).toPromise().then(function (response) {
                        var energyMeterId = [];
                        response.result.forEach(function (value) {
                            energyMeterId.push(value.meterSerialNumber + "(" + value.assetName + ")");
                        });
                        energyMeterId.push("All");
                        _this.selectedEnergyMeter = energyMeterId[0];
                        _this.meterSerialNumber = energyMeterId;
                        _this.timeFilter = _this.timeOptions[0];
                        _this.selectedparameter = _this.parameters[0];
                    });
                    this.EmsdashboardService.getAlertDataReport({ "deviceid": "E002B23", "meterid": "1", "duration": "Today" }).toPromise().then(function (response) {
                        _this.dataSource = new MatTableDataSource(response.result);
                        _this.dataSource.paginator = _this.paginator;
                        _this.reportData = response.result;
                    });
                }
                if (type == "energyMeter") {
                    this.EmsdashboardService.getAlertDataReport({ "deviceid": this.device, "meterid": param, "duration": this.timeFilter }).toPromise().then(function (response) {
                        _this.dataSource = new MatTableDataSource(response.result);
                        _this.dataSource.paginator = _this.paginator;
                        _this.reportData = response.result;
                    });
                }
                if (type == "parameter") {
                    console.log("Selected Paramter is", param);
                }
                if (type == "date") {
                    param_1 = this.timeFilter;
                    metername_1 = this.selectedEnergyMeter.split('(')[0];
                    if (param_1 == "Custom") {
                        console.log("customa value");
                        dialogConfig = new MatDialogConfig();
                        dialogRef = this.matDialog.open(CustomDateComponent, {
                            autoFocus: false,
                            height: '350px', width: '450px', data: { "details": "", "action": "Add", selectedDate: this.customeSelectedDate }
                        });
                        dialogRef.afterClosed().subscribe(function (value) {
                            _this.startdate = value.startDate;
                            _this.enddate = value.endDate;
                            _this.EmsdashboardService.getAlertDataReport({ "deviceid": _this.device, "meterid": metername_1, "duration": _this.timeFilter, "startDate": _this.startdate, "endDate": _this.enddate }).toPromise().then(function (response) {
                                _this.dataSource = new MatTableDataSource(response.result);
                                _this.dataSource.paginator = _this.paginator;
                                _this.reportData = response.result;
                            });
                        });
                    }
                    else {
                        this.EmsdashboardService.getAlertDataReport({ "deviceid": this.device, "meterid": metername_1, "duration": this.timeFilter }).toPromise().then(function (response) {
                            _this.dataSource = new MatTableDataSource(response.result);
                            _this.dataSource.paginator = _this.paginator;
                            _this.reportData = response.result;
                        });
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    return EmsalertreportComponent;
}());
export { EmsalertreportComponent };
